import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import LockScreenLoading from "../LockScreenLoading/LockScreenLoading";
import FullScreenDialog from "./FullScreenDialog";
import CirculationCreateForm from "../Circulation/CirculationCreateForm";
// Material-UI Element
// Custom Style
import { oceanBlueColor } from "../../styles/jss/cmsMainStyle";
import { confirmDialogStyle } from "../../styles/jss/components/dialog/confirmDialogStyle";

// Fetch Data
import {
  fileUpload,
  fileDownload,
  addFileProperty,
} from "../../dataSource/fileManager";
import { saveRFI, generatePdf } from "../../dataSource/rfi";
import { saveTransmittal } from "../../dataSource/transmittal";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles((theme) => confirmDialogStyle(theme));

const ToCirculationConfirmDialog = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    open,
    type,
    dialogTitle,
    attentionContent,
    cancelAction,
    confirmDialogHandleClose,
    circulationHandleClose,
    transmittal,
    rfi_seq,
    xmtl_seq,
    ref_no,
    dialogContent,
    buildAlert,
  } = props;
  const [fileUploadingProperty, setFileUploadingProperty] = useState([]);
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [openCirculationDialog, setOpenCirculationDialog] = useState(false);

  const [propertyFiles, setPropertyFiles] = useState([]);
  const [progressTitle, setProgressTitle] = useState("");
  const [renewCircList, setRenewCircList] = useState(0);
  // Main Action
  const fileUploadAction = (fileType, acceptedFilesPool) => {
    let UploadingSource = buildFileUploadingProperty(acceptedFilesPool);
    acceptedFilesPool.map((file) => {
      fileUpload(file).then((res) => {
        console.log(
          "*****************************************************************************"
        );
        console.log("Temporary upload File Successful");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
        UploadingSource = removeFileUploadingProperty(UploadingSource, file);
        // buildFileRecordFromHarddisk(fileType, res.data[0])
        buildFileRecord(fileType, res.data[0]);
      });
    });
  };
  const buildFileUploadingProperty = (fileUploadRecord) => {
    const res = [...fileUploadingProperty, ...fileUploadRecord];

    setFileUploadingProperty(res);
    dispatch({
      type: "ADD_FILE_UPLOADING_PROPERTY",
      data: res,
    });

    return res;
  };
  const removeFileUploadingProperty = (sourceRecords, key) => {
    if (sourceRecords) {
      const res = sourceRecords.filter((sourceRecord) => sourceRecord !== key);

      setFileUploadingProperty(res);
      dispatch({
        type: "ADD_FILE_UPLOADING_PROPERTY",
        data: res,
      });

      return res;
    }
  };

  const buildFileRecord = (fileType, fileUploadRecord) => {
    fileUploadRecord.modifydate = "";
    propertyFiles.push(fileUploadRecord);
  };
  const confirmAction = async (type) => {
    if (type === "fromRFI") {
      let rfiAttachment = {};
      rfiAttachment.rfi_seq = rfi_seq;
      rfiAttachment.ref_no = ref_no;
      rfiAttachment.transmittal = transmittal;
      setLockScreenLoadingOpen(true);
      confirmDialogHandleClose();
      await saveRFI(rfiAttachment).then((res) => {
        buildFileRecord("rfi", res.data.data[0]);
        setLockScreenLoadingOpen(false);
        alert("The RFI is added to Circulation");
        setOpenCirculationDialog(true);
      });
    }
    if (type === "fromXMTL") {
      let xmtlAttachment = {};
      xmtlAttachment.xmtl_seq = xmtl_seq;
      xmtlAttachment.ref_no = ref_no;
      setLockScreenLoadingOpen(true);
      confirmDialogHandleClose();
      await saveTransmittal(xmtlAttachment).then((res) => {
        buildFileRecord("transmittal", res.data.data[0]);
        setLockScreenLoadingOpen(false);
        alert("The Transmittal is added to Circulation");
        setOpenCirculationDialog(true);
      });
    }
  };

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <FullScreenDialog
        open={openCirculationDialog}
        dialogTitle={`New Circulation`}
        formContent={
          <CirculationCreateForm
            setLockScreenLoadingOpen={setLockScreenLoadingOpen}
            openDialog={openCirculationDialog}
            buildAlert={buildAlert}
            renewCircList={renewCircList}
            setRenewCircList={setRenewCircList}
            closeCirculationDialog={circulationHandleClose}
            presetFiles={propertyFiles}
          />
        }
        button={[]}
        handleClose={() => {
          setOpenCirculationDialog(false);
        }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={true}
        // onClose={handleClose}
        aria-labelledby="confirmDialogTitle"
        aria-describedby="confirmDialogDescription"
        PaperProps={{
          style: {
            background:
              "linear-gradient(0deg, " +
              oceanBlueColor[4] +
              ", " +
              oceanBlueColor[0] +
              ")",
          },
        }}
      >
        <DialogTitle id="confilmDialogTitle">{dialogTitle}</DialogTitle>

        <DialogContent>
          <DialogContentText
            id="confirmDialogContent"
            className={classes.content}
          >
            {dialogContent}
          </DialogContentText>

          <DialogContentText
            id="confirmDialogContent"
            className={classes.attentionContent}
          >
            {attentionContent ? "Attention: " + attentionContent : ""}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={cancelAction}
            className={classes.actionButton}
            autoFocus
          >
            Cancel
          </Button>

          <Button
            onClick={() => {
              confirmAction(type);
            }}
            className={classes.actionButton}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ToCirculationConfirmDialog;
